import { cn } from "@app/lib/utils";
import { openCookiePreferences } from "@design-system/atoms";
import { isApple } from "@design-system/layouts/utils";

interface ManageCookiesButtonProps {
  className?: string;
  children?: React.ReactNode;
}

export function ManageCookiesButton({
  className = "",
  children,
}: ManageCookiesButtonProps) {
  const isMac = isApple();

  return (
    <button
      onClick={openCookiePreferences}
      className={cn(
        "text-sm text-white text-opacity-70 underline transition-colors hover:text-bright-orange",
        isMac ? "mac-font" : "not-italic",
        className,
      )}
    >
      {children || "Manage Cookies"}
    </button>
  );
}
